/* Drawer add-ons — version null-safe (ne crash plus si un élément manque) */
(function () {
  function initDrawerAddonsCarousels() {
    document.querySelectorAll(".drawer-addons-group .drawer-addons-carousel").forEach(function (carousel) {
      if (carousel.swiper) carousel.swiper.destroy(true, true);
      var nextEl = carousel.querySelector(".swiper-button-next.drawer-addons-nav");
      var prevEl = carousel.querySelector(".swiper-button-prev.drawer-addons-nav");
      var pagEl  = carousel.querySelector(".swiper-pagination.drawer-addons-pagination");
      try {
        new Swiper(carousel, {
          slidesPerView: 1.2,
          spaceBetween: parseInt(carousel.style.gap) || 10,
          slidesOffsetBefore: 10,
          slidesOffsetAfter: 10,
          loop: false,
          navigation: { nextEl: nextEl, prevEl: prevEl },
          pagination: { el: pagEl, clickable: true }
        });
      } catch (e) {}
    });
  }
  document.addEventListener("DOMContentLoaded", initDrawerAddonsCarousels);
  document.addEventListener("drawerAddonsRendered", initDrawerAddonsCarousels);
})();

/* Ouverture du tiroir via le hamburger — protégé contre les éléments manquants */
document.addEventListener("DOMContentLoaded", function () {
  var drawer   = document.querySelector(".drawer-addons-group");
  var overlay  = document.querySelector(".drawer-overlay");
  var menuIcon = document.querySelector(".header__icon--menu");

  if (menuIcon && drawer) {
    menuIcon.addEventListener("click", function () {
      drawer.classList.toggle("open");
      if (overlay) {
        if (drawer.classList.contains("open")) {
          overlay.classList.add("active");
        } else {
          overlay.classList.remove("active");
        }
      }
    });
  }
});

/* Sous-menus repliables */
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll("[link-collapsing]").forEach(function (item) {
    var summary = item.querySelector("summary");
    if (!summary) return;
    summary.addEventListener("click", function (e) {
      e.preventDefault();
      if (item.hasAttribute("open")) {
        item.removeAttribute("open");
        item.classList.remove("menu-opening");
        summary.setAttribute("aria-expanded", "false");
      } else {
        item.setAttribute("open", "");
        item.classList.add("menu-opening");
        summary.setAttribute("aria-expanded", "true");
      }
    });
  });
});